import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-bold-eye',
    standalone: true,
    imports: [],
    templateUrl: './icon-bold-eye.component.html',
    styleUrl: './icon-bold-eye.component.scss'
})
export class IconBoldEyeComponent {
    @Input() color: string = 'currentColor';
    @Input() size: string = '24px';
}
